import debounce from 'lodash.debounce'
import * as React from 'react'

interface Props<T> {
  value: T
  debounceMs?: number
}

export function useDebouncedValue<T>({ value, debounceMs = 300 }: Props<T>) {
  const [debouncedValue, setDebouncedValue] = React.useState<T>()

  React.useEffect(() => {
    const setValue = () => {
      setDebouncedValue(value)
    }
    const setValueDebounced = debounce(setValue, debounceMs)

    setValueDebounced()

    return () => {
      setValueDebounced.cancel()
    }
  }, [value, debounceMs])

  return debouncedValue
}
